// This file is automatically generated. Do not edit manually.

import { FrontendUploadFileHandle } from "src/api/generated/common/frontendUploadFileHandle";
import { NumberSequence } from "src/api/generated/erp/db/types/tables/numberSequence";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartImportApi {
	export async function getFormInitData(): Promise<PartImportApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPart/import/getFormInitData",
			method: "POST",
			data: {},
		});
		return response as PartImportApi_FormInitData;
	}

	export async function importParts(args: {
		fileHandle: FrontendUploadFileHandle;
		partNoNumberSequenceId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPart/import/importParts",
			method: "POST",
			data: {
				fileHandle: args.fileHandle,
				partNoNumberSequenceId: args.partNoNumberSequenceId,
			},
		});
		return response as void;
	}
}

export interface PartImportApi_FormInitData {
	numberSequenceOptions: Array<NumberSequence>;
}
